// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__bQdp4","label":"default_label__eLLMc","fields":"default_fields__1FfdI","field":"default_field__bTnnQ","separator":"default_separator__NK7vp"};